/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Partner } from './Partner';
import {
    PartnerFromJSON,
    PartnerFromJSONTyped,
    PartnerToJSON,
    PartnerToJSONTyped,
} from './Partner';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    roles: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    active: boolean;
    /**
     * 
     * @type {Partner}
     * @memberof User
     */
    partner: Partner | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    signature?: string | null;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('partner' in value) || value['partner'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'roles': json['roles'],
        'active': json['active'],
        'partner': PartnerFromJSON(json['partner']),
        'signature': json['signature'] == null ? undefined : json['signature'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'email': value['email'],
        'roles': value['roles'],
        'active': value['active'],
        'partner': PartnerToJSON(value['partner']),
        'signature': value['signature'],
    };
}

